import * as React from 'react';
import '../css/jump-nav.sass';
import '../css/form-input-core.sass';

interface JumpNavLinkProps {
  id: string;
  sectionId: string;
  label: string;
}

export default function JumpNavLink(props: JumpNavLinkProps) {
  return (
    <a
      href={`#${props.sectionId}`}
      id={props.id}
      onMouseDown={e => {
        e.preventDefault();
      }}
    >
      {props.label}
    </a>
  );
}
